import * as React from 'react';
import { GraphGradient, graphGradients } from '../config/gradients';

export default (gradients: GraphGradient[]) => (
  <defs>{gradients.map((gradient) => graphGradients[gradient])}</defs>
);
